"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarTabContent = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var userSettings_1 = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var AvatarPicker_1 = require("components/AvatarPicker");
var avatars_1 = require("components/Avatar/avatars");
var mapStateToProps = function (state) {
    return {
        isOpen: state.user.userSettings.isOpen,
        avatar: state.user.userSettings.userInfo.avatar
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    changeAvatar: function (value) { return dispatch((0, userSettings_1.updateValue)('avatar', value)); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen) {
            if (this.props !== nextProps) {
                return true;
            }
        }
        return false;
    }
}), recompose_1.pure);
exports.AvatarTabContent = enhance(function (props) {
    return (React.createElement("div", { className: 'avatar-information' },
        React.createElement("div", { className: 'avatar-selection' }, props.avatar.length === 0 ? (React.createElement("div", null,
            React.createElement(sok_ui_1.Icon, { key: 'user', className: 'fa-user' }))) : (React.createElement("img", { key: props.avatar, className: 'avatar-icon', src: (0, avatars_1.getAvatarUrl)(props.avatar), width: 200, height: 200 }))),
        React.createElement(AvatarPicker_1.AvatarPicker, { selectedAvatar: props.avatar, onAvatarPicked: props.changeAvatar })));
});
